import { TProductoSolicitudExViewModel, TwEmbalajesExViewModel } from '../productos/productosEx.types';
import { TwSolicitudJerarquiaExViewModel } from '../datosbasicos/datosbasicosEx.types';
import { UsuarioViewModel } from '../../../_mantenimiento/usuarios/usuarios.types';

export class SolicitudLaboratorioExViewModel {
    public Id: number;
    public IdEstadoSolicitudEx: number;
    public IdEstadoSolicitudExDescripcion = '';
    public IdTipoSolicitudEx: number;
    public IdTipoSolicitudExDescripcion = '';
    public IdEstadoCertificadoFitoEx: number;
    public IdEstadoCertificadoFitoExDescripcion = '';
    public IdResultadoEnvioMuestrasLaboratorioEx: number | null;
    public DescripcionIdResultadoEnvioMuestrasLaboratorioEx: string;
    public CodigoTipoSolicitud = '';
    public CodigoSolicitudEx = '';
    //public CodigoTraces = '';
    //public EsPredua = false;
    public EsPrevia = false;
    public EsReExportacion = false;
    public IdSubTipoSolicitudEx: number | null;
    public IdSubTipoSolicitudExDescripcion: string;
    public TUsuario: UsuarioViewModel;
    public TLaboratorio: TLaboratorioSolicitudExViewModel;
    public TwTcMotivoMuestraLaboratorioExCollection: MotivoMuestraLaboratorioExViewModel[];
    public TwMotivoMuestraLaboratorioExCollection: MotivoMuestraLaboratorioSolicitudExViewModel[];
    public TProductoSolicitudExCollection: TProductoSolicitudExViewModel[];
    public TwEmbalajesExCollection: TwEmbalajesExViewModel[];
    public TwSolicitudJerarquiaEx: TwSolicitudJerarquiaExViewModel;
    public TwEnvioMuestraLaboratorioSolicitudEx: TwEnvioMuestraLaboratorioSolicitudExViewModel;
    public TwEnvioMuestraLaboratorioSolicitudExCollection: TwEnvioMuestraLaboratorioSolicitudExViewModel[];
    public TwResultadoEnvioMuestraLaboratorioSolicitudEx: TwResultadoEnvioMuestraLaboratorioSolicitudExViewModel;
    public TwDocumentoMuestraLaboratorioSolicitudExCollection: DocumentoMuestraLaboratorioSolicitudExViewModel[];
}

export class EnvioMuestrasLaboratorioSolicitudExInspectorViewModel {
    public TwEnvioMuestraLaboratorioSolicitudEx: TwEnvioMuestraLaboratorioSolicitudExViewModel = new TwEnvioMuestraLaboratorioSolicitudExViewModel();
    public TwMotivoMuestraLaboratorioSolicitudEx: TwMotivoMuestraLaboratorioSolicitudExViewModel = new TwMotivoMuestraLaboratorioSolicitudExViewModel();
    public TwResultadoEnvioMuestraLaboratorioSolicitudEx: TwResultadoEnvioMuestraLaboratorioSolicitudExViewModel =
        new TwResultadoEnvioMuestraLaboratorioSolicitudExViewModel();
}

export class TwEnvioMuestraLaboratorioSolicitudExViewModel {
    public IdSolicitudEx: number;
    public IdLaboratorio: number;
    public IdUsuario: number;
    public FechaEnvio: Date;
    public ObservacionesEnvio = '';
}

export class TwMotivoMuestraLaboratorioSolicitudExViewModel {
    public IdSolicitudEx: number;
    public MotivosExCollection: MotivoMuestraLaboratorioSolicitudExViewModel[];
    public ProductosExCollection: TProductoSolicitudExViewModel[];
    public EmbalajesExCollection: TwEmbalajesExViewModel[];
}

export class TwResultadoEnvioMuestraLaboratorioSolicitudExViewModel {
    public IdSolicitudEx: number;
    public IdResultadoEx: number;
    public IdTecnico: number | null;
    public FechaResultado: Date | null;
    public ObservacionesResultado = '';

    public TwDocumentoMuestraLaboratorioSolicitudExCollection: DocumentoMuestraLaboratorioSolicitudExViewModel[];
}

export class TLaboratorioSolicitudExViewModel {
    public Id: number;
    public IdSolicitudEx: number;
    public IdUsuario: number;
    public NombreUsuario = '';
    public Observaciones = '';
    public Fecha: Date | null;
}

export class MotivoMuestraLaboratorioSolicitudExViewModel {
    public Id: number;
    public IdSolicitudEx: number;
    public IdMotivoEx: number;
    public DescripcionMotivo: string;
}

export class DocumentoMuestraLaboratorioSolicitudExViewModel {
    public Id: number | null;
    public IdSolicitudEx: number;
    public Texto = '';
    public Fecha?: Date | null;
    public NombreArchivo = '';
    public CodigoStorage = '';
    public Size: number;
    public IdUsuario: number | null;
    public MarkToDelete?: number;
    public IdDocFileSystem?: number;
}

export enum TwTcResultadoEnvioMuestraLaboratorioExEnum {
    Pendiente = 1,
    Aceptada = 2,
    Rechazada = 3,
}

export class ResultadoEnvioMuestraLaboratorioExViewModel {
    public Id: number;
    public Descripcion = '';
}

export class MotivoMuestraLaboratorioExViewModel {
    public Id: number;
    public Descripcion = '';
}
